const FLOW_TYPE = 'FLOW_TYPE';
const CBAND_FLOW = 'CBAND_FLOW';
const HOME_LINE = 'home_line';
const CCATTEMPTS = 'ccAttempts';
const FIVEG_LINE = '5g_line';
const IS_RESUME_FLOW = 'isResumeFlow';
const REGSKIP = 'regSkip';
const SHOW = 'show';
const COUNT = 'count';
const DELIVERY_DATE = 'deliveryDate';
const PAYMENT_CALL = 'paymentCall';
const SHOW_EID = 'showEid';
const BACK_ORDER = 'isBackOrder';
const SET_RESUME_ABANDONED = 'SET_RESUME_ABANDONED';
export const INCLUDED_CHOICE_PROMO_TITLE = 'Also included, on us';
export const UPDATE_PLAN_JOURNEY = 'UPDATE_PLAN_JOURNEY';
export const PROGRESSIVE = 'PROGRESSIVE';
export const POPULAR = 'POPULAR';
export const POPULAR_CUSTOMIZED = 'POPULAR_CUSTOMIZED';
export const planJourneyCodes = {
  PROGRESSIVE: { path: 'custom', action: 'customized' },
  POPULAR: { path: 'popular', action: 'preset' },
  POPULAR_CUSTOMIZED: { path: 'recommended', action: 'modify' },
};

export {
  FLOW_TYPE,
  CBAND_FLOW,
  HOME_LINE,
  CCATTEMPTS,
  FIVEG_LINE,
  IS_RESUME_FLOW,
  REGSKIP,
  SHOW,
  COUNT,
  DELIVERY_DATE,
  PAYMENT_CALL,
  SHOW_EID,
  BACK_ORDER,
  SET_RESUME_ABANDONED,
};

export const WIFI_BACKUP = 'wifibackup';
export const wifiBackUpBannerNotification = 'Wi-Fi Backup provides 7 days of internet coverage when your daily primary internet is down.';
export const FWA_PLANS = 'fwaplans';
export const SEVENDAYS_ID = '70099';
export const THUNDER_WHW_PRODUCTIDS = ['70116', '70125', '70124'];
export const THUNDER_ROUTER_PRODUCTIDS = ['70118', '70093', '70123'];
export const GETPERK_PRODUCTIDS = ['70102', '70103', '70117', '70126'];
export const THUNDER_GETPERK_PRODUCTIDS = ['70117', '70126'];
export const THUNDER_PLANS = ['62032', '62031', '61964', '62036', '61963', '61986', '62030', '61987', '64228', '63688', '63687'];
export const THUNDER_WHW_PLAN_IDS = ['62030', '62036', '62032', '75561', '75560', '75565', '75322', '64228'];
export const ADDRESS_ID = [
  400145038100, 300000089041, 300000367867, 300001042552, 300004820726, 300007103432, 300007488725, 300011091741, 300062360613, 300062697617,
  300081087981, 300183258940, 300194440180, 300515439070,
];
